<template>
  <tooltip :label="$t(params.tooltipKey)" append-to-body>
    <div class="icon-header">
      <icon :icon="params.icon" :size="IconSize.XS" />
    </div>
  </tooltip>
</template>

<script>
import { Icon, IconSize } from '@/components/Icon';
import Tooltip from '@/components/Tooltip/Tooltip.vue';

export default {
  components: { Icon, Tooltip },
  computed: {
    IconSize() {
      return IconSize;
    },
  },
};
</script>

<style scoped lang="scss">
.icon-header {
  @apply flex items-center justify-center w-full;
}
</style>
